<template>
  <div>

    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">个人资料</span>
      </div>
      <div class="gl_tb_right"
           @click="showUserData()">
        <a href="javascript:;"
           class="gl_tb_right_more">
          <img src="/image/geren/bianji.png"
               class="gltb_moreimg">
          <span class="normalColor">编辑个人资料</span>
        </a>
      </div>
    </div>
    <div class="formWrap">

      <div class="display_center_ud marginTop20 marginBottom40">
        <!-- <img :src="apiData.headImg" class="marginRight40"> -->
        <!-- <el-upload action="123" :http-request="upLoad"  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"> -->
        <img v-if="form.headUrl"
             :src="form.headUrl"
             style=" width:110px;height:110px;border-radius: 50% "
             class="marginRight40">
        <!-- <div class="PerData_con_image_cover">
              修改头像
            </div> -->
        <!-- </el-upload> -->
        <div class="marginRight40"
             v-if="this.form.org == 1">
          <img src="/image/geren/dunpai.png">
          <p class="marginTop10">机构认证</p>
        </div>
        <div v-if="this.form.doctor == 1">
          <img src="/image/geren/shizixing.png">
          <p class="marginTop10">医生圈认证</p>
        </div>
      </div>
      <div class="marginBottom50"
           style="width: 600px;">
        <div class="display_between marginBottom20">
          <!-- <div class="display_center_ud flex1">
            <div class="formTitle">
              用户ID:
            </div>
            <div class="formcontent">
              {{AuthorId}}
            </div>
          </div> -->
          <div class="display_center_ud flex1">
            <div class="formTitle">
              昵称:
            </div>
            <div class="formcontent">
              {{form.nickname}}
            </div>
          </div>
          <div v-if="ishoworg==true"
               class="display_center_ud flex1">
            <div class="formcontent">
              <div data-v-36eef558=""
                   class="cltbtn"
                   style="margin-left:0;background: rgb(11, 133, 134);"
                   @click="GetOrganInfoList()">加入机构</div>
            </div>
          </div>
        </div>
        <div class="display_between marginBottom20">
          <div class="display_center_ud flex1">
            <div class="formTitle">
              手机号:
            </div>
            <div class="formcontent">
              {{form.phone}}
            </div>
          </div>
          <div class="display_center_ud flex1">
            <div class="formTitle">
              学历:
            </div>
            <div class="formcontent">
              {{form.Education}}
            </div>
          </div>
        </div>
        <div class="display_between marginBottom20">
          <div class="display_center_ud flex1">
            <div class="formTitle">
              姓名:
            </div>
            <div class="formcontent">
              {{form.userName}}
            </div>
          </div>
          <div class="display_center_ud flex1">
            <div class="formTitle">
              科室:
            </div>
            <div class="formcontent">
              {{form.AdmiOffice}}
            </div>
          </div>
        </div>
        <div class="display_between marginBottom20">
          <div class="display_center_ud flex1">
            <div class="formTitle">
              身份证号:
            </div>
            <div class="formcontent">
              {{form.IDcard}}
            </div>
          </div>
          <div class="display_center_ud flex1">
            <div class="formTitle">
              职称:
            </div>
            <div class="formcontent">
              {{form.JobTitle}}
            </div>
          </div>
        </div>
        <div class="display_between marginBottom20">
          <div class="display_center_ud flex1">
            <div class="formTitle">
              邮箱:
            </div>
            <div class="formcontent">
              {{form.mail}}
            </div>
          </div>
          <div class="display_center_ud flex1">
            <div class="formTitle">
              所在地区:
            </div>
            <div class="formcontent">
              {{region}}
            </div>
          </div>
        </div>
        <div class="display_between marginBottom20">
          <div class="display_center_ud flex1">
            <div class="formTitle">
              单位:
            </div>
            <div class="formcontent">
              {{form.unit}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="机构选择"
               :visible.sync="isOrganUser"
               class="Courselist"
               width="856px">
      <div class="cltop">
        <el-input placeholder="请输入机构名称"
                  prefix-icon="el-icon-search"
                  class="cltinput"
                  v-model="orgname">
          <el-button style="background: #0B8586;"
                     slot="append"
                     @click="getOrganUserList">搜索</el-button>
        </el-input>
        <div class="cltbtn"
             @click="toAddOrganUser">确定</div>
      </div>
      <el-table :data="OrganInfoList"
                :row-key="getRowKey"
                border>
        <el-table-column label=""
                         width="40">
          <template slot-scope="scope">
            <el-radio :label="scope.row"
                      v-model="checkedGh"
                      style="color: #fff;padding-left: 5px;border-color:#666"></el-radio>
          </template>
        </el-table-column>
        <el-table-column property="id"
                         label="ID"
                         width="100"></el-table-column>
        <el-table-column property="org_name"
                         label="机构名称名称"></el-table-column>
      </el-table>
    </el-dialog>
  </div>

</template>

<script>
import axios from 'axios';
import { areaList } from '@vant/area-data';
export default {
  inject: ['reload'],
  name: "userMyInforShow",
  data () {
    return {
      apiData: "",
      form: {
        // 头像
        headUrl: '',
        // 机构认证
        org: '',
        // 医生圈认证
        doctor: '',
        // 医生会员认证
        doctorType: false,
        // 手机号
        phone: '',
        // 姓名
        userName: '',
        // 单位
        unit: '',
        // 微信ID
        wxid: '',
        // 学历
        Education: '',
        // 职称
        JobTitle: '',
        // 科室
        AdmiOffice: '',
        //身份证号
        IDcard: '',
        nickname: '',
        mail: ''
      },
      // 用户个人信息
      userPerInfo: '',
      // 用户id
      AuthorId: '',
      bindingWeChatFalse: false,
      ishoworg: false,
      isOrganUser: false,
      OrganInfoList: [],
      orgname: "",
      checkedGh: null,
      region: ''
    }
  },
  methods: {
    getRowKey (row) {
      return row.id
    },
    getData () {
      var that = this;
      fetch("/data.json").then((res) => {
        return res.json()
      }).then(data => {
        that.apiData = data.userMyInforShow
      })
    },
    showUserData () {
      this.$router.push({
        path: '/user/userData'
      });
    },
    upLoad (file) {
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('Authorid', this.AuthorId)
      formData.append('OfType', 1)
      this.httphelper.post('/api/OssFileApi/ImageUpload', formData).then((res) => {
        if (res.data.code) {
          this.$message({
            message: '头像上传成功',
            type: 'success'
          })
          this.form.headUrl = res.data.data.src
          //刷新页面
          this.reload();
        } else {
          this.$message('头像上传失败失败');
        }
      })
    },
    handleAvatarSuccess (res, file) {
      this.form.headUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 PNG 格式 或者 JPG!');
      }
      if (!isLt10M) {
        this.$message.error('上传头像图片大小不能超过 10MB!');
      }
      return (isJPG || isPNG) && isLt10M;
    },
    // 手机号中间四位隐藏
    mobileStr (str) {
      if (str.length > 7) {
        return str.substring(0, 3) + '****' + str.substring(7, str.length);
      } else {
        return str.substring(0, str.length - 1) + '****';
      }
    },
    // 获取用户个人信息
    getUserInfo () {
      this.httphelper.post('/api/CGpUserApi/GetUserMessage', {
        id: parseInt(this.AuthorId)
      }).then((res) => {
        // 绑定微信
        this.bindingWeChat = res.data.data.bindingWeChat
        this.userPerInfo = res.data.data
        this.form.headUrl = this.userPerInfo.avatarUrl
        if (this.userPerInfo.mobile) {
          this.form.phone = this.mobileStr(this.userPerInfo.mobile)
        } else {
          this.form.phone = ''
        }
        this.form.userName = this.userPerInfo.userName
        this.form.unit = this.userPerInfo.unit
        this.form.org = this.userPerInfo.org
        this.form.doctor = this.userPerInfo.doct
        this.form.Education = this.userPerInfo.educatId
        this.form.JobTitle = this.userPerInfo.professionalId
        this.form.AdmiOffice = this.userPerInfo.admoffId
        this.form.nickname = this.userPerInfo.nickname
        this.form.IDcard = this.userPerInfo.iDcard
        this.form.mail = this.userPerInfo.mail
        if (this.bindingWeChat == 0) {
          this.bindingWeChatFalse = false
        } else if (this.bindingWeChat == 1) {
          this.bindingWeChatFalse = true
        }
        // 医生会员认证
        if (this.userPerInfo.doctorType == 0) {
          this.form.doctorType = true
        } else if (this.userPerInfo.doctorType == 1 || this.userPerInfo.doctorType == 9) {
          this.form.doctorType = false
        }

        // // 学历
        if (this.userPerInfo.educatId == 0) {
          this.form.Education = ''
        } else {
          this.form.Education = this.userPerInfo.educatId
          this.getEcujobam(1);
        }
        // 职称
        if (this.userPerInfo.professionalId == 0) {
          this.form.JobTitle = ''
        } else {
          this.form.JobTitle = this.userPerInfo.professionalId
          this.getEcujobam(2);
        }
        // 科室
        if (this.userPerInfo.admoffId == 0) {
          this.form.AdmiOffice = ''
        } else {
          this.form.AdmiOffice = this.userPerInfo.admoffId
          this.getEcujobam(3);
        }
        for (let a in areaList.province_list) {
          if (a == this.userPerInfo.province) {
            this.region = areaList.province_list[a]
          }
        }
        for (let a in areaList.city_list) {
          if (a == this.userPerInfo.city) {
            this.region = this.region + ' / ' + areaList.city_list[a]
          }
        }
        for (let a in areaList.county_list) {
          if (a == this.userPerInfo.district) {
            this.region = this.region + ' / ' + areaList.county_list[a]
          }
        }
      })
    },
    // 获取学历、职称、科室
    getEcujobam (type) {
      axios.get('/api/BasicsmesApi/GetCodeResultList?type=' + type).then((res) => {
        if (type == 1) {
          this.Eduoption = res.data.data
          res.data.data.forEach((item) => {
            if (item.id == this.userPerInfo.educatId) {
              this.form.Education = item.valueText
            }
          })
        } else if (type == 2) {
          this.Joboption = res.data.data
          res.data.data.forEach((item) => {
            if (item.id == this.userPerInfo.professionalId) {
              this.form.JobTitle = item.valueText
            }
          })
        } else if (type == 3) {
          this.AdmiOfficeData = res.data.data
          res.data.data.forEach((item) => {
            if (item.id == this.userPerInfo.admoffId) {
              this.form.AdmiOffice = item.valueText
            }
          })
        }
      })
    },
    //根据用户判断是否显示加入机构按钮
    GetOrganUser () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganUser', {
          OrgId: 0,
          UserId: this.AuthorId
        })
        .then(res => {
          if (res.data.code == 200) {
            this.ishoworg = true;
          }
        });
    },
    GetOrganInfoList () {
      this.isOrganUser = true
    },
    toAddOrganUser () {
      if (this.checkedGh == null || this.checkedGh.id == '') {
        this.$message.warning('请选择机构');
        return
      }
      this.httphelper
        .post('/api/CGPEnterPriseApi/SaveOrganUser', {
          orgId: this.checkedGh.id,
          userId: this.AuthorId,
        })
        .then(res => {
          if (res.data.code == 200) {
            this.ishoworg = false;
            this.$message.success('加入成功,请等待审核结果');
          } else {
            this.$message.error('该机构已经绑定!');
          }
          this.isOrganUser = false
        });
    },
    getOrganUserList () {
      if (this.orgname == '') {
        this.$message.warning('请输入机构名称查询');
        return
      }
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganInfoList', {
          Name: this.orgname//模糊查询机构名称
        })
        .then(res => {
          if (res.data.code == 200) {
            //返回模糊搜索出的机构列表
            this.OrganInfoList = res.data.data
          }
        });
    },
    getCurrentRow (row) {
      this.checkedGh = row.id
    }
  },
  created () {
    if (localStorage.getItem('ResData')) {
      this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
    }
    //加入机构操作
    this.GetOrganUser()
    this.getUserInfo()
  },
  components: {
  }
}
</script>

<style scoped>
.formWrap {
    position: relative;
}

.fixedTips {
    position: absolute;
    background: url(/image/geren/bgbj.png) center no-repeat;
    width: 251px;
    height: 269px;
    right: 0;
}

.input {
    width: 100%;
    height: 35px;
    box-sizing: border-box;
}

.renzhengbtn {
    display: inline-block;
    width: 120px;
    height: 30px;
    background: #785513;
    border-radius: 15px;
    text-align: center;
    line-height: 30px;
    color: #fff;
}

.formTitle {
    margin-right: 20px;
    text-align: right;
    /* width: 60px; */
    color: #8d8d8d;
}
.cltop {
    display: flex;
    margin-bottom: 20px;
}
.cltbtn {
    width: 97px;
    height: 40px;
    background: #c32424;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fffefe;
    line-height: 40px;
    text-align: center;
    border-radius: 4px;
    margin-left: 10px;
}
.cltinput {
    flex: 1;
}
.cltinput ::v-deep .el-input__inner {
    border-color: #0b8586;
}
.cltinput ::v-deep .el-input-group__append,
.cltinput ::v-deep.el-button {
    background-color: #0b8586;
    color: #fffefe;
    border-color: #0b8586;
}
.cltinput ::v-deep.el-button {
    width: 97px;
    font-family: Microsoft YaHei;
}
.Courselist ::v-deep .el-radio__inner {
    border-color: #aaaaaa;
}
</style>
